import { Grid, Paper, Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import PriceList from "./PriceList";

const HowToSteps = () => {
  const { t } = useTranslation();
  const steps_sell = [
    {
      title: t("steps_sell.s1.title"),
      description: t("steps_sell.s1.description"),
    },
    {
      title: t("steps_sell.s2.title"),
      description: t("steps_sell.s2.description"),
    },
    {
      title: t("steps_sell.s3.title"),
      description: t("steps_sell.s3.description"),
    },
  ];
  return (
    <Box
      sx={{
        py: {
          xs: 6, // mobile
          sm: 6, // tablets
          md: 12, // desktops
          xl: 30,
        },
        pb: {
          md: 10,
          xl: 20,
        },
        px: {
          xs: 2, // mobile
          sm: 12, // tablets
          md: 20, // desktops
          xl: 65,
        },
        textAlign: "center",
        backgroundColor: "primary.superlight",
      }}
    >
      <Typography variant="h2" sx={{ mb: 4, color: "rgb(1, 47, 77)" }}>
        {t("steps_sell.title")}
      </Typography>
      <Grid
        container
        spacing={3}
        justifyContent="center"
        sx={{ mb: { xs: 6, md: 14, xl: 16 } }}
      >
        {steps_sell.map((step, index) => (
          <Grid item xs={12} sm={4} key={index}>
            <Paper elevation={1} sx={{ p: 3 }}>
              <Typography variant="h6" sx={{ color: "rgb(1, 47, 77)" }}>
                {index + 1}. {step.title}
              </Typography>
              <Typography>{step.description}</Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>

      <Typography
        variant="h2"
        sx={{ mb: { xs: 2, md: 0, xl: 4 }, color: "rgb(1, 47, 77)" }}
      >
        {t("steps_sell.title2")}
      </Typography>

      <PriceList />
    </Box>
  );
};

export default HowToSteps;
